<template>
  <div>
    <Modal
      v-model="fix_modal"
      :closable="false"
      :mask-closable="false"
      title="修改站点"
      :styles="{top: '10px'}"
      width="90%"
    >
      <Row type="flex" align="top">
        <table-user-basic ref="userBasic" :formProps="data1" SiteClass></table-user-basic>
        <table class="lida-leading-table">
          <tbody>
            <tr>
              <td>
                <table class="lida-table-content" v-if="Object.keys(data2).length">
                  <thead>
                    <th colspan="2" width="40%">设定</th>
                    <th>预视</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="tableinforcolor">
                        <p class="tr mr-4">是否安全碼設置</p>
                      </td>
                      <td class="text-left pl-3">
                        <RadioGroup v-model="data2[16]">
                          <Radio :label="'1'">是</Radio>
                          <Radio :label="'0'">否</Radio>
                        </RadioGroup>
                        <div>
                          <span>安全碼:</span>
                          <Input
                            type="text"
                            v-model="data2[17]"
                            placeholder="請輸入安全碼"
                            style="width:75%;"
                            :disabled="data2[16] == 0"
                          />
                        </div>
                      </td>
                      <td class="tableinforcolor" rowspan="10">
                        <Row>
                          <Col span="12">
                            <p class="tl">公司图片</p>
                            <img height="150px" :src="imagesrc(5)" @error="errorimg" />
                          </Col>
                          <Col span="12">
                            <p class="tl">大Logo</p>
                            <img height="150px" :src="imagesrc(12)" @error="errorimg" />
                          </Col>
                          <Col span="6">
                            <p class="tl">公司QR图片</p>
                            <img height="150px" :src="imagesrc(6)" @error="errorimg" />
                          </Col>
                          <Col span="6">
                            <p class="tl">客服QR1</p>
                            <img height="150px" :src="imagesrc(9)" @error="errorimg" />
                          </Col>
                          <Col span="6">
                            <p class="tl">客服QR2</p>
                            <img height="150px" :src="imagesrc(10)" @error="errorimg" />
                          </Col>
                          <Col span="6">
                            <p class="tl">客服QR3</p>
                            <img height="150px" :src="imagesrc(11)" @error="errorimg" />
                          </Col>
                        </Row>
                      </td>
                    </tr>
                    <tr>
                      <td class="tableinforcolor">
                        <p class="tr mr-4">客服系统</p>
                      </td>
                      <td class="text-left pl-3">
                        <RadioGroup v-model="data2[14]">
                          <Radio :label="'1'">啟用</Radio>
                          <Radio :label="'0'">停用</Radio>
                        </RadioGroup>
                        <div>
                          <span>客服網址:</span>
                          <Input
                            type="text"
                            v-model="data2[15]"
                            placeholder="客服網址"
                            style="width:75%;"
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="tableinforcolor">
                        <p class="tr mr-4">公司名称</p>
                      </td>
                      <td>
                        <Select v-model="data2[7]" class="mr-1" style="width:40%">
                          <Option
                            v-for="item in select"
                            :value="item.value"
                            :key="item.value"
                          >{{ item.label }}</Option>
                        </Select>
                        <Input v-model="data2[4]" style="width:50%;" />
                      </td>
                    </tr>
                    <tableTr v-for="it in imageTr" :key="it.key" :title="it.title">
                      <upload-image
                        :_class="it.key"
                        :title="it.title"
                        :fix_modal="fix_modal"
                        :imgname="data2[it.key]"
                        :transfer="false"
                        @pushImageList="pushImageList"
                        @removeImageList="removeImageList"
                        @Reset="resetdmigcash"
                        ref="uploadImage"
                      ></upload-image>
                    </tableTr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </Row>
      <div slot="footer">
        <Button type="primary" @click="fix_modal = false">取消</Button>
        <Button type="error" @click="PostAcountFix">修改</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import UploadImage from "./UploadImage";
import TableUserBasic from './TableUserBasic'
import tableTr from './tableTr'
export default {
  name: 'ModalAcountFix',
  inject: ["GetAcountListTable"],
  components: {
    TableUserBasic,
    UploadImage,
    tableTr
  },
  data () {
    return {
      fix_modal: false,
      data1: {},
      data2: {},
      data2default: {}, // 預設值
      imageTr: [
        { key: '5', title: '公司图片', imgname: "cplogo" },
        { key: '12', title: '大Logo', imgname: "biglogo" },
        { key: '6', title: '公司QR', imgname: "cpQr" },
        { key: '9', title: '公司QR_1', imgname: "cuImg1" },
        { key: '10', title: '公司QR_2', imgname: "cuImg2" },
        { key: '11', title: '公司QR_3', imgname: "cuImg3" }
      ],
      form: {
        pass: "",
        checkpass: ""
      },
      select: [
        { value: "1", label: "公司名称" },
        { value: "2", label: "Logo图片" }
      ],
      migcash: new Date().getTime(),
      file: null
    };
  },
  computed: {
    ...mapGetters(["getmember"]),
  },
  watch: {
    fix_modal (val) {
      let tiemr
      if (!val) {
        tiemr = setTimeout(() => {
          this.form.pass = "";
          this.form.checkpass = "";
          this.data2 = {}
          this.data1 = {}
          this.resetImageList()
        }, 500)
      } else {
        clearTimeout(tiemr)
      }
    }
  },
  methods: {
    imagesrc (data) {
      const res = this.data2[data]
      if (!res) return
      return `${process.env.VUE_APP_IMAGE_URL}/img/` + res + ".jpge?" + this.migcash;
    },
    errorimg (event) {
      event.target.src = require('assets/img/defaultImage.png')
    },
    async GetAcountFixData (id) {
      try {
        const res = await this.$axios.acount.mauge(id)
        if ('status' in res && res.status === 0) return
        this.data1 = res[0];
        this.GetAcountFixLoginPassAndImage(id);
        this.fix_modal = true;
      } catch (error) {
        console.error(error)
      }
    },
    async GetAcountFixLoginPassAndImage (id) {
      try {
        const res = await this.$axios.acount.memdebr(id)
        if ('status' in res && res.status === 0) return
        res.forEach((it, i) => this.$set(this.data2, it.class, it.misve))
        this.data2default = Object.assign({}, this.data2)
      } catch (error) {
        console.error(error)
      }
    },
    async PostAcountFix () {
      try {
        if (this.form.pass == this.form.checkpass) {
          const user = this.$refs.userBasic.form;
          const userData =
            ['upass', 'state', 'phone', 'email', 'islinkodds', 'unified_draw', 'siteClass']
              .reduce((acc, key) => {
                acc[key] = user[key]
                return acc
              }, {})
          // 產生需傳入的 misarr 資料
          let misarr = []
          Object.keys(this.data2).forEach(it => {
            const index = this.imageTr.findIndex(item => item.key == it)
            if (index == -1 || 'file' in this.imageTr[index]) { // 不是圖片的資料或判斷是否有上傳圖片資料
              if (!this.data2[it]) return // 空值
              if (index == -1 && this.data2default[it] == this.data2[it]) return // 未修改
              misarr.push({ class: it, misve: this.data2[it] })
            }
          })

          const data = {
            loid: this.getmember.pid,
            mid: this.data1.id,
            mname: user.memname,
            ...userData,
            misarr: misarr,
            itemslimits: [],
            itemspcomis: []
          };

          let formData = new FormData();
          formData.append('objdata', JSON.stringify(data));
          this.imageTr.forEach(it => {
            if ('file' in it) formData.append(it.imgname, it.file);
          })
          const res = await this.$axios.acount.update_member(formData);
          if ('data' in res && res.data.status === 1) {
            this.$Message.success("修改成功");
            this.GetAcountListTable();
            this.resetdmigcash()
            this.fix_modal = false;
          }
        } else {
          this.$Message.warning("密码与密码确认不相符");
        }
      } catch (error) {
        console.log(error);
        this.$Message.error("网路异常");
      }
    },
    resetdmigcash () { // 刷新時間戳，讓圖片可以更新
      this.migcash = new Date().getTime();
    },
    pushImageList ({ file, _class }) { // 存入 imageTr file
      const index = this.imageTr.findIndex(it => it.key == _class)
      this.$set(this.imageTr[index], 'file', file)
    },
    removeImageList (_class) { // 清除 單一 imageTr file
      const index = this.imageTr.findIndex(it => it.key == _class)
      delete this.imageTr[index].file
    },
    resetImageList () { // 清除 imageTr file
      this.imageTr = this.imageTr.map(it => {
        delete it.file
        return it
      })
    }
  }
};
</script>
